export const API = {
  AUTH: {
    VERIFY: "/api/auth/verify",
    REFRESH: "/api/auth/refresh-token",
  },
  TEMPLATE: {
    LIST: "/api/campaign-templates",
    CREATE: "/api/campaign-templates",
    UPDATE: (templateId: string) => `/api/campaign-templates/${templateId}`,
    DETAIL: (templateId: string) => `/api/campaign-templates/${templateId}`,
    COPY: (templateId: string) => `/api/campaign-templates/${templateId}/copy`,
  },
  PORTFOLIO: {
    CATEGORY: "/api/portfolio-categories",
  },
  CAMPAIGN: {
    LIST: "/api/campaign-v2",
    CREATE: "/api/campaign-v2",
    UPDATE: (campaignId: string) => `/api/campaign-v2/${campaignId}`,
    DETAIL: (campaignId: string) => `/api/campaign-v2/${campaignId}`,
    UPDATE_STATUS: "/api/campaign-v2",
    DOWNLOAD_REPORT: (campaignId: string) => `/api/campaign-v2/${campaignId}/download`,
    FETCH_CAMPAIGN_PARAMS: (type: string) =>
      `api/campaign-v2/campaign-params/${type}`,
    COPY_CAMPAIGN: (campaignId: string | number) =>
      `api/campaign-v2/${campaignId}/copy`,
  },
  LOAN_PARAMS: {
    DEALER_MASTER: "/api/campaign-v2/loan-params/dealer-masters",
  },
  UPLOAD: {
    LIST: "/api/campaign-upload",
    DETAIL_FILE: (fileId: number) => `/api/campaign-upload/${fileId}`,
    CREATE: "/api/bulk-upload",
    UPDATE_MAPPING: (fileId: number) =>
      `/api/bulk-upload/${fileId}/update-mapping`,
    VALIDATE_MAPPING: (fileId: number) =>
      `/api/bulk-upload/${fileId}/validate-mapping`,
    FILE_ERROR: (fileId: number) => `/api/bulk-upload/${fileId}/error-file`,
    DETAIL: (fileId: number) => `/api/bulk-upload/user/${fileId}`,
    DOWN_FILE: (fileId: number) => `/api/bulk-upload/${fileId}/file`,
  },
  CUSTOMER_PARAMS: {
    LOCATION_MASTER: "/api/campaign-v2/customer-params/location",
  },
};

export const ACCESS_TOKEN = "access_token";

export const DEFAULT_FORMAT_DATE = "DD MMM YYYY, hh:mm A";
export const TVS_FORMAT_DATE = "DD/MM/yyyy";
export const TVS_FORMAT_DATE_TIME = "DD/MM/yyyy HH:mm";

export const NEPAL_TZ = "Asia/Kathmandu";

export const MONTH_NAMES = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
] as const;

export const CAMPAIGN_PREFIX = "TVSD";

export const PAGINATION = {
  MIN_PAGE: 1,
  MAX_PAGE: 1000,
  MIN_LIMIT: 10,
  MAX_LIMIT: 100,
} as const;
